module.exports = __webpack_public_path__ + "img/sucai.31efcc50.png";